import React from "react";
import { Box } from "../../../shared/components/ui/chakra";
import { Text } from "@chakra-ui/react";

type BusinessEntityChipProps = {
  children: string;
};

export const BusinessEntityChip = ({
  children,
}: BusinessEntityChipProps) => {
  return (
    <Box px={3} py={1} borderRadius="full" bgColor="#F5f5f5">
      <Text fontSize={"xs"} mt={"1px"}>
        {children}
      </Text>
    </Box>
  );
};
